import { PlateTypeEnum } from '../../../models/cutting/cutting-panel-outline.model';

// @dynamic
export class FastenerSessionStorageManager {
  private static lastSelectedFastenerIdentifier = 'last_selected_fastener';
  private static lastSelectedPlateIdentifier = 'last_selected_fastener_plate';

  static get lastSelectedPlate(): PlateTypeEnum {
    const lastSelectedPlate: string | null = sessionStorage.getItem(this.lastSelectedPlateIdentifier);

    if (lastSelectedPlate == null) {
      return PlateTypeEnum.Face;
    } else {
      return +lastSelectedPlate as PlateTypeEnum;
    }
  }

  static set lastSelectedPlate(val: PlateTypeEnum) {
    sessionStorage.setItem(this.lastSelectedPlateIdentifier, val.toString());
  }

  static get lastSelectedFastener(): SessionFastener | undefined {
    const lastSelectedFastener: string | null = sessionStorage.getItem(this.lastSelectedFastenerIdentifier);

    if (lastSelectedFastener == null) {
      return undefined;
    } else {
      return JSON.parse(lastSelectedFastener) as SessionFastener;
    }
  }

  static set lastSelectedFastener(val: SessionFastener) {
    sessionStorage.setItem(this.lastSelectedFastenerIdentifier, JSON.stringify(val));
  }
}

export interface SessionFastener {
  id: number;
  type: FastenerType;
}

export enum FastenerType {
  FastenerSet,
  Hole,
}
